"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _bcmKunrenActions = require("../bcmKunrenActions");
var _ReportCommonDetail = _interopRequireDefault(require("./components/ReportCommonDetail"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 訓練実施報告削除結果
 */
class KunrenReportDeleteResult extends _react.default.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      intl,
      previousReportEntry,
      goMain,
      kunrenInfo
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_KUNREN_REPORT_DELETE_RESULT
      }),
      actions: [/*#__PURE__*/_react.default.createElement(_CButton.default, {
        onClick: () => goMain(true),
        autoWidth: true,
        negative: true
      }, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
      }))]
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 8
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: 'delete'
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 4
      },
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_CButton.default, {
      onClick: () => goMain(true),
      autoWidth: true,
      negative: true
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ReportCommonDetail.default, {
      reportEntry: previousReportEntry,
      kunrenInfo: kunrenInfo
    })))));
  }
}
const mapStateToProps = state => ({
  previousReportEntry: state.bcmKunren.previousReportEntry,
  kunrenInfo: state.bcmKunren.kunrenInfo
});
const mapDispatchToProps = dispatch => {
  return {
    goMain: doSearch => dispatch(_bcmKunrenActions.bcmKunrenActions[_bcmKunrenActions.TYPES.GO_MAIN](doSearch))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)(KunrenReportDeleteResult));